import axiosInstance from '../utils/axios';

/**
 * 블루투스 장치 관리 API 서비스
 */
const bluetoothService = {
  /**
   * 블루투스 장치 목록 조회
   * @param {Object} params - 조회 파라미터
   * @param {number} params.page - 페이지 번호
   * @param {number} params.pageSize - 페이지 크기
   * @param {string} params.keyword - 검색 키워드
   * @param {number} params.searchKind - 검색 종류 (0:전체, 1:회원명, 2:아이디, 3:이메일)
   * @returns {Promise<Object>} API 응답
   */
  async getBluetoothDeviceList(params = {}) {
    try {
      const {
        page = 1,
        pageSize = 10,
        keyword = '',
        searchKind = 0
      } = params;

      const response = await axiosInstance.get('/bluetooth/list', {
        params: {
          page,
          pageSize,
          keyword,
          searchKind
        }
      });

      return response.data;
    } catch (error) {
      console.error('블루투스 장치 목록 조회 실패:', error);
      return {
        success: false,
        message: error.response?.data?.message || '블루투스 장치 목록 조회에 실패했습니다.',
        data: null
      };
    }
  },

  /**
   * 블루투스 장치 상세 정보 조회
   * @param {number} idx - 블루투스 장치 ID
   * @returns {Promise<Object>} API 응답
   */
  async getBluetoothDeviceDetail(idx) {
    try {
      const response = await axiosInstance.get(`/bluetooth/${idx}`);

      return response.data;
    } catch (error) {
      console.error('블루투스 장치 상세 조회 실패:', error);
      return {
        success: false,
        message: error.response?.data?.message || '블루투스 장치 상세 조회에 실패했습니다.',
        data: null
      };
    }
  },

  /**
   * 엑셀 다운로드용 블루투스 장치 데이터 조회
   * @param {string} keyword - 검색 키워드
   * @param {number} searchKind - 검색 종류
   * @returns {Promise<Object>} API 응답
   */
  async getBluetoothExcelData(keyword = '', searchKind = 0) {
    try {
      const response = await axiosInstance.get('/bluetooth/excel', {
        params: {
          keyword,
          searchKind
        }
      });

      return response.data;
    } catch (error) {
      console.error('블루투스 엑셀 데이터 조회 실패:', error);
      return {
        success: false,
        message: error.response?.data?.message || '엑셀 데이터 조회에 실패했습니다.',
        data: []
      };
    }
  },

  /**
   * 리포트용 엑셀 다운로드 데이터 조회
   * @param {string} keyword - 검색 키워드
   * @param {number} searchKind - 검색 종류
   * @returns {Promise<Object>} API 응답
   */
  async getReportExcelData(keyword = '', searchKind = 0) {
    try {
      const response = await axiosInstance.get('/bluetooth/report-excel', {
        params: {
          keyword,
          searchKind
        }
      });

      return response.data;
    } catch (error) {
      console.error('리포트 엑셀 데이터 조회 실패:', error);
      return {
        success: false,
        message: error.response?.data?.message || '리포트 데이터 조회에 실패했습니다.',
        data: []
      };
    }
  },

  /**
   * 검색 자동완성을 위한 사용자 정보 조회
   * 
   * @param {string} keyword - 검색 키워드
   * @param {number} searchKind - 검색 종류 (0:전체, 1:회원명, 2:아이디, 3:이메일)
   * @returns {Promise<Array>} 사용자 정보 목록
   */
  async getSearchSuggest(keyword, searchKind = 0) {
    try {
      const response = await axiosInstance.get('/bluetooth/search-suggest', {
        params: {
          keyword,
          searchKind
        }
      });

      if (response.data.success) {
        return response.data.data;
      } else {
        console.error('User search failed:', response.data.message);
        return [];
      }
    } catch (error) {
      console.error('Error searching users for auto-complete:', error);
      return [];
    }
  }
};

export default bluetoothService;
